import { apiHelper } from '@/utils/api.helper'
import { ORDER_ADD_CART_ITEM, ORDER_EDIT_CART_ITEM, ORDER_DELETE_CART_ITEM, ORDER_CHANGE_CART_VOLUME_VARIATION } from '@/store/order.module'

const productMixin = {
  data() {
    return {
      productList: {
        category: [],
        products: [],
        total_items: 0
      },
      productData: {
        product: {
          product_name: '',
          voucher_value: '',
          voucher_expired_date: '',
          wish_id: null
        },
        hasWish: false,
        loading: true
      }
    }
  },
  methods: {
    getProductList(category = '') {
      apiHelper(false)
        .get(`page/shop?category=${category}`)
        .then((res) => {
          this.productList = res
        })
        .catch((err) => console.log(err))
    },
    getProduct(productId) {
      return apiHelper()
        .get(`page/productdetails/${productId}`)
        .then((res) => {
          let data = res

          this.productData.product = data.product
          this.productData.product.total_reviews = data.total_reviews

          this.productData.hasWish = data.hasWish == 1
          this.productData.images = data.images
        })
        .catch((err) => {
          // return to voucher listing page if hit error
          // and prompt error
          console.log(err)
          // this.router.push({ name: ROUTE_NAME.VOUCHER });
        })
        .finally(() => (this.productData.loading = false))
    },
    // addToCart(productId, quantity)
    addToCart(requestObj) {
      this.$store.dispatch(ORDER_ADD_CART_ITEM, requestObj)
    },
    editCartItem(items) {
      let requestObj = {
        products: items.map((item) => {
          let body = {
            product_id: item.product_id,
            quantity: item.cart_quantity,
            is_checked: item.is_checked
          }
          if (item.volume_variation === 1) Object.assign(body, { product_volume_variation_id: item.product_volume_variation_id })
          return body
        })
      }
      return this.$store.dispatch(ORDER_EDIT_CART_ITEM, requestObj)
    },
    deleteCartItems(requestObj) {
      this.$store.dispatch(ORDER_DELETE_CART_ITEM, requestObj)
    },
    changeVolumeVariation(requestObj) {
      this.$store.dispatch(ORDER_CHANGE_CART_VOLUME_VARIATION, requestObj)
    }
  }
}

export default productMixin
